export const Iso5218Sex = {
  MALE: "MALE",
  FEMALE: "FEMALE",
  NOT_APPLICABLE: "NOT_APPLICABLE",
  NOT_KNOWN: "NOT_KNOWN",
};
